import { useState, useRef, useCallback } from 'react';

export function useReadyWaiter() {
  const [isResolved, setIsResolved] = useState(false);

  const promiseRef = useRef<Promise<void> | null>(null);
  const resolveRef = useRef<(() => void) | null>(null);

  const promise = useCallback(() => {
    if (promiseRef.current) {
      return promiseRef.current;
    }

    promiseRef.current = new Promise<void>(resolve => {
      if (isResolved) {
        resolve();
        return;
      }
      resolveRef.current = resolve;
    });

    return promiseRef.current;
  }, [isResolved]);

  const resolve = useCallback(() => {
    if (!isResolved) {
      setIsResolved(true);
      resolveRef.current?.();
      // we can biff resolveRef.current now. . .
      resolveRef.current = null;
    }
  }, [isResolved, setIsResolved]);

  const reset = useCallback(() => {
    setIsResolved(false);
    promiseRef.current = null;
    resolveRef.current = null;
  }, [setIsResolved]);

  return {
    promise,
    resolve,
    reset,
    isResolved,
  };
}
